import React, { FC } from 'react';
import { SubPage } from 'components/pages/ozone-design/sub-page';
import { Recommendations } from './recommendations';
import { Typeface } from './typeface';

export const Typography: FC = () => (
  <SubPage title="Typography">
    <Typeface />
    <Recommendations />
  </SubPage>
);
